import { sanitizeRichTextHtml } from "@/utils/sanitizeRichTextHtml";

interface DetailItem {
  id: string;
  label: string;
  value: string;
  isHtml?: boolean;
}

interface DetailViewProps {
  data: DetailItem[];
}

export const DetailView = ({ data }: DetailViewProps) => {
  return (
    <div className="overflow-hidden rounded-xl border border-gray-200 bg-white">
      <div className="divide-y divide-[#D8D8D8]">
        {data.map((detail) => (
          <div key={detail.label} className="grid grid-cols-12 odd:bg-[#FAFAFA] even:bg-white">
            <div className="col-span-12 sm:col-span-4 bg-gray-200 px-4 py-3 text-sm font-medium text-gray-900">
              {detail.label}
            </div>
            <div className="col-span-12 sm:col-span-8 px-4 py-3 text-sm text-gray-900 whitespace-pre-line">
              {detail.isHtml ? (
                <div dangerouslySetInnerHTML={{ __html: sanitizeRichTextHtml(detail.value) }} />
              ) : (
                detail.value
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
